import { IDataTableOptionalProps } from "../../DataTable/common/defaults";

export const roleTableColumns = [
    {
        title:"Edit Role",
        data:'id'
    },
    {
        title:"Name",
        data:"name"
    },
    {
        title:"IsActive",
        data:(row,type,set,meta) => {
            return (row.AccountStatus != null) ? row.accountStatus.name : "Active";
        }
    }
]

export const roleTableOptions:IDataTableOptionalProps = {
    showSelectInfo: false,
    lengthChange:false,
    order:[[1,'asc']]
}


